// Spellbook.jsx
import React, { useState, useEffect } from 'react';
import './Spellbook.css';
import buildSpellbook from './Spell/helpers/buildSpellbook.js'
import fetch_spell from './Spell/helpers/fetch_spell.js';
import get_spell_name from './Spell/helpers/get_spell_name.js';

const Spellbook = ({ chardata, globalState }) => {

// INPUTS:
// globalState = [ currentChar, setChar, loggedIn, layout, setLayout, currentSpellArray, currentSpellDataArray, allSpellsArray ];
// chardata = "flattened" character data object, e.g. { myClass, mySp11, etc }

  const [ currentSpellData, setCurrentSpellData ] = globalState[6];
  const [spellbook, setSpellbook] = useState([]);

  const isMobile = /Mobi|Tabletop|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  useEffect(() => {
    buildSpellbook(chardata, globalState, setSpellbook);
  }, [chardata, globalState]);

  const handleRowClick = (spell) => {
    console.log("Row clicked:", spell.Name);
    setCurrentSpellData(spell);
    document.getElementById('spell-details').style.display = 'grid';
    // if #mobileSpellDetails exists, display it
    let mobileSpellDetails = document.getElementById('MobileSpellDetail');
    if ( mobileSpellDetails !== null ) { mobileSpellDetails.style.display = 'block' }
  }

  return (
    <div id={`${isMobile ? 'spellbook-UI-mobile' : 'spellbook-UI'}`} className="spellbook-container">
    <div id="spellbook-title">{chardata.name}'s Spellbook</div>
    {/* from here down it will be conditional on isMobile */}
      <table className={`spellbook-table ${isMobile ? 'mobile-table' : 'desktop-table'}`}>
        <thead>
          <tr>
            <th style={{ width: '5%' }}>Lvl</th>
            <th style={{ width: '20%' }}>Name</th>
            <th style={{ width: '8%' }}>Range</th>
            <th style={{ width: '8%' }}>{isMobile ? 'Cast' : 'Casting'}</th>
            <th style={{ width: '12%' }}>Duration</th>
            <th style={{ width: '36%' }}>AOE</th>
            <th style={{ width: '10%' }}>Effect</th>
            <th style={{ width: '9%' }}>Save</th>
            
          </tr>
        </thead>
        <tbody>
          {spellbook.map((spell, index) => (
            <tr key={index} onClick={() => handleRowClick(spell)}>
              <td>{spell.Lvl}</td>
              <td>{spell.Name}</td>
              <td>{spell.Range}</td>
              <td>{spell.Casting}</td>
              <td>{spell.Duration}</td>
              <td>{spell.AOE}</td>
              <td>{spell.Effect}</td>
              <td>{spell.Save}</td>
              
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Spellbook;